import { updateBrandList } from '@anm/helpers/branding';
import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { deleteBrandLogoAsync } from '../actions';
import { BrandActions, BrandState } from '../types';

import { initialBrandState } from '.';

const deleteBrandLogoReducer: Reducer<BrandState, BrandActions> = (
  state = initialBrandState,
  action
) => {
  switch (action.type) {
    case getType(deleteBrandLogoAsync.request): {
      const { logoId } = action.payload;

      return {
        ...state,
        deleteBrandLogo: {
          ...state.deleteBrandLogo,
          isPending: true,
          params: {
            deletedLogoId: `${logoId}`
          }
        }
      };
    }
    case getType(deleteBrandLogoAsync.success): {
      const { id: currentBrandId } = action.payload;

      const updatedBrandList = updateBrandList(
        state.brandsList.data,
        currentBrandId,
        state.deleteBrandLogo.params?.deletedLogoId
      );

      return {
        ...state,
        brandsList: {
          ...state.brandsList,
          data: updatedBrandList
        },
        deleteBrandLogo: {
          ...state.deleteBrandLogo,
          isPending: false
        }
      };
    }
    case getType(deleteBrandLogoAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        deleteBrandLogo: {
          ...state.deleteBrandLogo,
          error,
          isPending: false,
          isError: true
        }
      };
    }
    default:
      return state;
  }
};

export default deleteBrandLogoReducer;
